import CertsSidePanelFooter from './CertsSidePanelFooter';

export default CertsSidePanelFooter;
